// src/services/activityService.js
import api from './api';

import { authHeader } from '../helpers/auth-header';

export const userService = {

  getUserById, // Add this line
};

export const getUsers = async () => {
  try {

    const response = await api.get(`/user-activities/users/`, {
      headers: authHeader()
    });
    return response.data;
  } catch (error) {
    throw new Error('Failed to fetch activities');
  }
};

async function getUserById(id) {
  try {
    const response = await api.get(`/user-activities/users/${id}`, {
      headers: authHeader()
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching user with id ${id}:`, error);
    throw error;
  }
}

export const sendPushNotification = async (userIds, message) => {
  try {
    const response = await api.post('/user-activities/notifications/send', {
      userIds,
      message
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to send notification');
  }
};

export const deleteAccountWithCredentials = async (email, password) => {
  const response = await api.post('/auth/delete-account-with-credentials', {
    email,
    password
  });
  return response.data;
};